import request from '../../utils/request';

export function getAdminUsers(params) {
  return request('/admin-users', {
    method: 'GET',
    params: params,
  });
}

export function getAdminUser(id) {
  return request(`/admin-users/${id}`, {
    method: 'GET',
  });
}

export function createAdminUser(data) {
  return request('/admin-users', {
    method: 'POST',
    data,
  });
}

export function updateAdminUser(data) {
  const id = data.id;
  delete data.id;
  return request(`/admin-users/${id}`, {
    method: 'PATCH',
    data,
  });
}

export function removeAdminUser(id) {
  return request(`/admin-users/${id}`, {
    method: 'DELETE',
  });
}
